<script>

///Ultima alteração: 27/05/2020
///Alterado por: Allinne

    import { afterUpdate }      from 'svelte';

    export let gallery              = null;
    export let selectedPhotoIndex   = null;
    
    let galleryId                   = 'lightgallery-' +  Math.random(0, 100).toString().substr(2);

    function fixPhotoPath(path) {
		if (!path.startsWith('http://') && !path.startsWith('https://')) {
			return `${atria.mainURL}${path}`;
		}

		return path;
	}
    afterUpdate(() => {
        try{
            jQuery('.' + galleryId).lightGallery({
                selector: '.item',
                share: false,
                download: false
            });
        }catch(ex) {}

        if (selectedPhotoIndex != null) {
            jQuery(`.${galleryId} .item`).eq(selectedPhotoIndex).click();
        }
    });
</script>

{#if gallery != null}
    <ul class="{galleryId}" style="display: none;">
        {#each gallery as photo, i}
            <li class="item item--{i}" data-thumb="{fixPhotoPath(photo.Path)}" data-src="{fixPhotoPath(photo.Path)}">
                <img onerror="ImageNotFound(this);" src="{fixPhotoPath(photo.Path)}" alt="{photo.Title}"/>
            </li>
        {/each}
    </ul>
{/if}